import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { ActiveUserMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/ActiveUsersCloums';
import { useIntl, useHistory } from 'umi';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { getCompanyRevenueDownloadValueOfCvm, findRevenueData } from '../_utils';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    tabId,
    tableTotal,
    dataSource = 'appannie',
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    entityType = 'mobile',
  } = props;
  const history = useHistory();
  const { formatMessage } = useIntl();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: tabId,
    currentRatioType: 0,
  });
  const defaultPageSize = 5;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    setSortTableData(tableData);
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e?.ratioType || 0,
    });
    onTableSortChage(e);
    // 将页码重置,与接口一至
    setPageIndex(1);
    setPageSize(defaultPageSize);
  };

  const getMetricCloums = (dataSource: string) => {
    const metricCloums: any[] = [];
    columnsList?.forEach((t: any) => {
      metricCloums.push(
        ActiveUserMetricColumn({
          isNoDropdown: t.value?.indexOf(tabId) === -1,
          dataSource: dataSource === 'ogdb' ? 'databarin' : dataSource,
          title: t.title,
          textContent: t.textContent,
          key: `${t.value}_${dataSource}`,
          sortMetric: t.value,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${dataSource}_${currentRatioType}`,
          onSortChage,
          renderType: t?.renderType,
          width: columnsList?.length === 1 ? 'auto' : t?.width,
          width_cn: columnsList?.length === 1 ? 'auto' : t?.width_cn,
          getMetricValueOfCvm: (cvm: any, sortMetric: string) => {
            const metric = findRevenueData(cvm?.games_metrics, sortMetric, dataSource);
            return getCompanyRevenueDownloadValueOfCvm(metric);
          },
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, entityType));
  };

  return (
    <>
      <TopchartTable
        recordKey="app_id"
        loading={tableLoading}
        records={sortTableData}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'app_id',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">{formatMessage({ id: 'dbi_games' })}</span>
                <span className="stats-table-title-subtext">({tableTotal || 0})</span>
              </div>
            ),
            width: 300,
            align: 'left',
            render: (cvm: any) => {
              if (cvm?.id === 'All Games') {
                return <>{formatMessage({ id: 'dbi_detail_table_allgames' })}</>;
              }
              return (
                <ARightClickToJump
                  href={getDetailGameOverviewPath(cvm?.id, entityType)}
                  style={{ display: 'inline' }}
                >
                  <FirstRowEdition
                    name={cvm?.name}
                    isUnPublished={false}
                    platform={cvm?.platform}
                    imgSrc={cvm?.cover}
                    onClick={() => {
                      onClickGame(cvm?.id);
                    }}
                  />
                </ARightClickToJump>
              );
            },
          },
          ...getMetricCloums(dataSource),
        ]}
      />
    </>
  );
};

export default TrendsCard;
